;

'use strict';

(function ($, window, document) {
  $(document).ready(function () {
    /// Media OWL Carousel
    if ($('#media-carousel').length > 0) {
      var mediaCarousel = $('#media-carousel');

      mediaCarousel.owlCarousel({
        loop: false,
        autoplay: false,
        margin: 15,
        nav: false,
        dots: true,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1000: {
            items: 3
          },
          1500: {
            items: 3
          }
        }
      });
    }
  });

  $(document).ready(function () {
    /// Media OWL Carousel
    if ($('#noticiasprod-carousel').length > 0) {
      var noticiasProdCarousel = $('#noticiasprod-carousel');

      noticiasProdCarousel.owlCarousel({
        loop: false,
        autoplay: false,
        margin: 15,
        nav: false,
        dots: true,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1000: {
            items: 3
          },
          1500: {
            items: 3
          }
        }
      });
    }
  });

})(jQuery, window, document);